import classNames from "classnames";
import { RichText } from "components/RichTextWidget";
import { useRef } from "react";
import {
  AccordionList,
  Container,
  DownloadFile,
  Heading3,
  Icon,
  ImageLite,
  SwiperLayout,
} from "shared/components";
import { useViewMode } from "shared/contexts/ViewMode";
import { SwiperSlide } from "swiper/react";

import styles from "./Content024.module.scss";

export const Content024 = ({ payload }) => {
  const title = payload?.title ?? "";
  const description = payload?.description ?? "";
  const points = payload?.points ?? [];
  const slider = payload?.slider ?? [];
  const { attachmentButtonText, file } = payload?.attachment ?? {};
  const { isDesktop } = useViewMode();

  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
    <div className={styles.wrapper}>
      <Container className={styles.inner}>
        <div className={styles.slider}>
          <SwiperLayout
            prevRef={prevRef}
            nextRef={nextRef}
            watchOverflow={false}
            slidesPerView={1}
            slidesPerGroup={1}
            loop={true}
            paginationWrapper={styles.pagination}
          >
            {slider.map((slide) => (
              <SwiperSlide key={slide.id} className={styles.slide}>
                <ImageLite image={slide} className={styles.image} />
              </SwiperSlide>
            ))}
          </SwiperLayout>
          <div className={styles["navigation-wrapper"]}>
            <div className={styles["slider-navigation"]}>
              <div
                ref={prevRef}
                className={classNames(
                  styles.navigation,
                  styles["navigation-prev"]
                )}
              >
                <Icon className={styles.icon} name="arrow_slider_prev" />
              </div>
              <div
                ref={nextRef}
                className={classNames(
                  styles.navigation,
                  styles["navigation-next"]
                )}
              >
                <Icon className={styles.icon} name="arrow_slider_next" />
              </div>
            </div>
            {isDesktop && <div className={styles.pagination}></div>}
          </div>
        </div>
        <div className={styles.blocks}>
          <div className={styles.left}>
            <Heading3 as="h3" className={styles.title} color="light">
              {title}
            </Heading3>
            <RichText
              value={description}
              className={styles.description}
              color="light"
            />
            <DownloadFile
              file={file}
              label={attachmentButtonText}
              color="light"
            />
          </div>
          <div className={styles.right}>
            <AccordionList
              items={points}
              className={styles.list}
              appearance="bold"
              color="light"
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Content024;
